import styled, { keyframes } from "styled-components";

// Matches the operator card it sits under (authorizedOperatorComponents.jsx): same
// surface, radius and column width. The left rule carries the state.
export const UpdateCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;

  background-color: #F6F8FF;
  border-radius: 10px;
  width: 210px;
  padding: 14px 16px 16px;
  margin: 12px auto 20px;
  border-left: 4px solid ${({ signal }) => signal};

  > * + * {
    margin-top: 10px;
  }

  /* Collapsed sidebar is 80px wide — the instruments panel opens in that state — so
     the full card does not fit and overflowed instead. The operator card next to it
     degrades the same way (see the body.sidebar-mini block in
     _sidebar-and-main-panel.scss): stripped down to its icon, restored in full when
     the sidebar expands to 260px on hover. */
  body.sidebar-mini .sidebar:not(:hover) & {
    width: auto;
    padding: 12px;
    background-color: transparent;
    border-left: 0;
    align-items: center;

    > * {
      display: none;
    }

    > .update-mini-icon {
      display: block;
    }
  }
`;

// Only visible while the sidebar is collapsed, where it is the entire card: an update
// waiting must stay noticeable without a 210px card to say so.
export const MiniIcon = styled.i`
  display: none;
  font-size: 26px;
  line-height: 1;
  color: ${({ signal }) => signal};
`;

export const Label = styled.p`
  color: ${({ signal }) => signal};
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin: 0;
`;

export const Title = styled.p`
  color: #283745;
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1.3;
  margin: 0;
`;

export const Note = styled.p`
  color: #5B6A80;
  font-size: 11.5px;
  line-height: 1.45;
  margin: 0;
`;

export const Meta = styled.p`
  color: #64748B;
  font-size: 11.5px;
  font-family: monospace;
  line-height: 1.5;
  margin: 0;
`;

export const Button = styled.button`
  border: 0;
  border-radius: 7px;
  padding: 9px 10px;
  width: 100%;

  font-size: 12.5px;
  font-weight: 600;
  color: #FFFFFF;
  background-color: ${({ signal }) => signal};
  cursor: pointer;

  &:disabled {
    background-color: #C3CADD;
    color: #7B869C;
    cursor: not-allowed;
  }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.span`
  display: inline-block;
  flex: none;
  width: 15px;
  height: 15px;
  border: 2px solid #D3DBEC;
  border-top-color: ${({ signal }) => signal};
  border-radius: 50%;
  animation: ${spin} 0.9s linear infinite;
`;

export const InlineRow = styled.div`
  display: flex;
  align-items: center;

  > * + * {
    margin-left: 8px;
  }
`;

// Every open panel is about to lose its connection, not just the one that clicked,
// so the warning covers the whole screen instead of living inside the card.
export const ApplyingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;

  background-color: rgba(35, 45, 70, 0.97);
  color: #FFFFFF;
`;

export const OverlayTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin: 20px 0 8px;
  color: #FFFFFF;
`;

export const OverlayText = styled.p`
  font-size: 0.95rem;
  line-height: 1.5;
  max-width: 34ch;
  color: rgba(255, 255, 255, 0.75);
`;

export const OverlayRing = styled.span`
  display: inline-block;
  width: 34px;
  height: 34px;
  border: 3px solid rgba(255, 255, 255, 0.25);
  border-top-color: #FFFFFF;
  border-radius: 50%;
  animation: ${spin} 0.9s linear infinite;
`;
